import { PageHeader, SidebarToggle, type PageHeaderProps } from '@elbklar/ui';

/**
 * Seitenkopf jeder Finanzen-Seite: PageHeader aus dem Design System, vorn der
 * Knopf für die Sidebar wie in CRM und PM (am Handy ausgeblendet, dort gibt es
 * die Tab-Leiste).
 */
export function SeitenKopf(props: Omit<PageHeaderProps, 'leading'>) {
  return <PageHeader {...props} leading={<SidebarToggle />} />;
}
